import { Drawer } from '@mui/material';
import type { Replace } from '@weft/utils';
import type { ComponentProps } from 'react';
import React from 'react';
import { FilterDrawerSection } from './filter-drawer-components/FilterDrawerSection';

type FilterDrawerProps = Replace<ComponentProps<typeof Drawer>, 'children', React.ReactElement<typeof FilterDrawerSection> | React.ReactElement<typeof FilterDrawerSection>[]>;

const FilterDrawer: {
  Section: typeof FilterDrawerSection;
} & React.FC<FilterDrawerProps> = ({ children, ...props }) => {
  return (
    <Drawer
      anchor="right"
      PaperProps={{
        className: 'max-w-[400px] py-10 px-7 gap-y-7',
      }}
      slotProps={{
        backdrop: {
          invisible: true,
        },
      }}
      {...props}
    >
      <p className="text-xl font-medium text-black">Filters</p>

      <div className="flex flex-col gap-y-[52px]">
        {children}
      </div>
    </Drawer>
  );
};

FilterDrawer.Section = FilterDrawerSection;

export { FilterDrawer };